import AbstractRequestTask from '../AbstractRequestTask';
import Launcher from '../../apa/Launcher';
import Utils from 'src/utils/Utils.js';

class LinkSessionsTask extends AbstractRequestTask {
  constructor(redirectUrl = null, method = 'POST', code = '', retries = 0, linkworkflowstartUrl = '') {
    super();
    this.redirectUrl = redirectUrl;
    this.version = 'v2';
	  this.method = method;
    this.code = code;
    this.retries = retries;
    this.params = super.getParams();
    this.user_token = this.params.user_token;
    this.linkworkflowstartUrl = linkworkflowstartUrl;
  }

  getMethod() {
    return this.method;
  }

  getEncType() {
	  return 'application/json';
  }

  getQueryStringParams() {
	  const params = super.getParams();
	  delete params.api_version;
	  delete params.HKS;
	  delete params.format;
	  delete params.user_id;
    delete params.device_name;
    delete params.device_so;
    delete params.user_token;
    
    // Construir redirectUrl concatenando parámetros del dispositivo
    let redirectUrlWithParams = this.redirectUrl;
    if (!redirectUrlWithParams) return '';
      const deviceParams = {};
      if (params.device_id) deviceParams.device_id = params.device_id;
      if (params.device_category) deviceParams.device_category = params.device_category;
      if (params.device_model) deviceParams.device_model = params.device_model;
      if (params.device_type) deviceParams.device_type = params.device_type;
      if (params.device_manufacturer) deviceParams.device_manufacturer = params.device_manufacturer;

      if (this.linkworkflowstartUrl) {
        try {
          // No se usa URLSearchParams porque no está disponible en todos los
          // dispositivos STV y rompe la construcción de la URL (AAFCL-1764).
          const queryString = String(this.linkworkflowstartUrl).split('?')[1] || '';
          const getQueryParam = (name) => {
            const pair = queryString
              .split('&')
              .find((p) => p.split('=')[0] === name);
            if (!pair) return null;
            const value = pair.split('=')[1] || '';
            try {
              return decodeURIComponent(value);
            } catch (e) {
              return value;
            }
          };
          const object_type = getQueryParam('object_type');
          const group_id = getQueryParam('group_id');
          const offer_id = getQueryParam('offer_id');
          const suscription_id = getQueryParam('suscription_id');
          if (object_type) {
            deviceParams.object_type = object_type;
            if ((object_type === 'A' || object_type === 'G') && offer_id) {
              deviceParams.offer_id = offer_id;
            }
            if (object_type === 'A' && suscription_id) {
              deviceParams.suscription_id = suscription_id;
            } else if (object_type === 'G' && group_id) {
              deviceParams.group_id = group_id;
            }
          }
        } catch (e) {
          // No se manda a console en prod; se reporta a NewRelic igual que AbstractRequestTask.parseErrors()
          if (typeof window.newrelic === 'object') {
            window.newrelic.noticeError(e);
          }
        }
      }

      if (Object.keys(deviceParams).length > 0) {
        const deviceQueryString = Utils.buildQueryParams(deviceParams);
        const separator = redirectUrlWithParams.includes('?') ? '&' : '?';
        redirectUrlWithParams = `${redirectUrlWithParams}${separator}${deviceQueryString}`;
      }
    
    
    const qsParams = Object.assign({}, params, { redirectUrl: encodeURIComponent(redirectUrlWithParams) });
    return Utils.buildQueryParams(qsParams);
  }

  getParams() {
    const params = super.getParams();
    delete params.api_version;
    delete params.device_name;
    delete params.device_so;
    delete params.format;
    delete params.user_id;
    delete params.HKS;
    delete params.user_token;
    return Object.assign({}, params);
  }

  getUrl() {
    const protocol = 'http';
    const server = Launcher.get("akamai_mfwk");
    const apiname = this.code ? `link-sessions/${encodeURIComponent(this.code)}` : 'link-sessions';
    const version = this.version;
    const endpoint = 'services/user';
    const urlLinkDevices = `${protocol}://${server}/${endpoint}/${version}/${apiname}?${this.getQueryStringParams()}`;
    return urlLinkDevices;
  }

  getHeaders() {
    return {
        'Authorization': `Bearer ${this.user_token}`,
        'Content-Type': 'application/json'
    };
  }

  getRetriesNumber() {
    return this.retries;
  }


  isValid(response) {
    if (response && response.errors) return false;
    return true;
  }
}

export default LinkSessionsTask;


// WEBPACK FOOTER //
// ./src/requests/tasks/opt/LinkSessionsTask.js